module.exports = __webpack_public_path__ + "static/media/cover-01.8c7ff4b4.jpg";